module.exports = __webpack_public_path__ + "static/media/Luna_Noel.ad300f25.pdf";